import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
import AdBanner from "../AdPage/AdBanner";
const AXIX = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  // const currentCards = CreditCardData.cards?.filter((card)=>card.category==="Credit card").slice(indexOfFirstCard, indexOfLastCard);
  // console.log({currentCards})
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("axis"))
    .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const faqs = [
    {
      question: "Do Axis Bank credit cards offer welcome bonuses?",
      answer:
        " Yes, most Axis cards come with attractive welcome benefits, including discounted flight tickets, vouchers, or reward points upon meeting initial spend criteri.",
    },
    {
      question: "What are the interest charges on Axis credit cards?",
      answer:
        "  Interest rates typically range from 2.5% to 3.6% per month (30%–43% annually), depending on the card type and user profile.",
    },
    {
      question: "Can I get lounge access with Axis cards?",
      answer:
        " Yes, many Axis credit cards offer complimentary domestic and international airport lounge access, particularly in the travel and premium card categories.",
    },
    {
      question: "Is there a lifetime free credit card from Axis Bank?",
      answer:
        "   Yes, Axis offers lifetime free options such as the MY Zone Easy Credit Card, but benefits may be limited compared to annual fee-based cards.",
    },
    {
      question: " How long does it take to receive an Axis Bank credit card?",
      answer:
        "  After approval, you’ll typically receive your physical card within 7–12 business days. Virtual cards may be issued instantly on some products.",
    },
  ];

  const steps = [
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-orange-500" />,
      title: "Apply via Axis Bank’s Official Portal",
      description:
        "  Once you've finalized your choice, click on “Apply Now” to be securely redirected to Axis Bank’s official credit card application portal, where you can complete the application process.",
    },
    {
      icon: <FaIdCard className="h-6 w-6 text-green-500" />,
      title: "Collect and Verify Required Documents",
      description:
        " Keep scanned copies or physical documents ready for identity proof, income verification, and address confirmation. This saves time when you move to the official application page.",
    },
    {
      icon: <FaUserCheck className="h-6 w-6 text-purple-600" />,
      title: "Check Your Eligibility",
      description:
        "Match your income level, age, and credit score with the eligibility criteria of the specific card you’re eyeing. This step ensures a smoother application process and better approval chances.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        " Head over to TheFinMaster and browse through our curated list of Axis Bank credit cards. Each card page features in-depth details on fees, benefits, cashback percentages, ideal user categories, and reward systems to help you find the perfect fit.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
        Axis Bank Credit Cards – Compare Offers & Apply Now
        </title>
        <meta
          name="description"
          content="Explore Axis Bank credit cards for lifestyle, travel, and more. Compare top cards and apply online."
        />
        <meta
          name="keywords"
          content="axis bank fixed deposit credit card, axis bank lic signature credit card, axis bank neo credit card lounge access, axis neo credit card lounge access, axisbank forex"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/axis-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Axis Bank Credit Cards
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>

        <div className="flex justify-center items-center  p-4 ">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Explore Top-Tier Credit Cards Packed with Rewards, Benefits, and
              Premium Experiences
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              Axis Bank offers one of the most diverse and feature-rich credit
              card portfolios in India. Whether you're looking for cashback,
              travel perks, lifestyle privileges, or business benefits, Axis
              Bank has a card tailored to your needs. With options for beginners
              to high-net-worth individuals, the cards are designed to deliver
              value, flexibility, and unmatched reward potential.
            </p>
          </div>
        </div>
        <h2 className="text-center text-2xl md:text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h2>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>
          <div className="w-full relative ">
            <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
              {/* <div className="w-[70%] mx-auto">
                                                           <h2 className="text-center font-medium pt-5 text-lg">
                                                             <span className="font-semibold text-white">816 people</span>{" "}
                                                             are on call with our advisors right now
                                                           </h2>
                                                         </div> */}
              <div className="w-full mx-auto">
               
                  <div className="w-[80%] mx-auto ">
                  <AdBanner displayOrder="2" />                  </div>
               
                <div className="bg-white">
                  {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                               Know your advisor
                                                             </h3> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

        {/* <div className='w-[95%] py-10'>
                <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                <AccordionComponent />
            </div> */}

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for Axis Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Age Limit
                  </span>
                  <span>
                    {" "}
                    Applicants should be between 18 and 70 years of age. Add-on
                    cardholders must be above 15 years. This age range ensures
                    legal and financial responsibility.
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Requirements
                  </span>
                  <span>
                    {" "}
                    Most Axis credit cards require a monthly income of
                    ₹15,000–₹50,000, depending on the card tier. Premium cards
                    may have higher income thresholds.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score Expectations
                  </span>
                  <span>
                    {" "}
                    A minimum CIBIL score of 700 is recommended. Higher scores
                    improve approval chances and may unlock better card variants
                    or higher credit limits.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Occupation Type
                  </span>
                  <span>
                    {" "}
                    Both salaried individuals and self-employed professionals
                    are eligible. Stable job history or business continuity may
                    be considered during evaluation.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Residency Status
                  </span>
                  <span>
                    {" "}
                    Only Indian residents with valid government-issued documents
                    can apply. Axis Bank serves most major cities and towns
                    across India.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for Axis Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Identity Proof
                  </span>
                  <span>
                    {" "}
                    Valid photo ID such as Aadhaar Card, Voter ID, Passport, or
                    PAN Card is required for authentication and KYC compliance.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Address Proof
                  </span>
                  <span>
                    {" "}
                    Submit documents like utility bills, rental agreements,
                    Aadhaar Card, or passport that confirm your current or
                    permanent residential address.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Proof
                  </span>
                  <span>
                    {" "}
                    Salaried: Last 3 months' salary slips and latest Form 16.
                    Self-employed: Latest ITR with financial statements or
                    audited business documents for income validation.{" "}
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Photograph
                  </span>
                  <span>
                    {" "}
                    A recent passport-sized color photograph must be provided,
                    preferably taken within the last 6 months.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Pan Card
                  </span>
                  <span>
                    {" "}
                    Mandatory for all applicants as it links to your financial
                    and credit history across institutions.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for Axis Bank Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          Applying for a fuel credit card is a seamless process that starts with
          the right research and ends at the official bank’s platform for final
          submission. Here’s how you can get started through TheFinMaster.com:
        </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AXIX;
